import page from 'page'
import { loadPageStarter } from '../config/app-starter.js'

import { showPage404 } from './404/index.js'
import adminRoutes from './admin/routes.js'

import { setupAuthRoutes } from './auth/routes.js'
import { setupUserRoutes } from './user/routes.js'
import { setupInviteRoutes } from './invite/routes.js'
import { setupXeroConnectRoutes } from './third-party-connector/connect-xero.js'

import { setupAccountRoutes } from './manage-account/routes.js'

import { setupFinancialsRoutes } from './financials/routes.js'
import { setupMongoToPgRoutes } from './mongo-to-pg/routes.js'
import { showHomePage } from './home/index.js'
import { appEntityRoutes } from './entity/routes.js'
import setRoutersProductionPulse from '../production-pulse/router-production-pulse.js'
import { setupOtherFeaturesRoutes } from '../pages-other-features/routes.js'

// Router using https://visionmedia.github.io/page.js/
// Last Updated 2020: React, VueJS and Angular probably took over.
// Flo still likes the simplicity of this front end router
//

// Set the base route urls
// Do not use: allows sub routers
// page.base('/app')
// page.base('')

// Home route and default redirect
page.redirect('/', '/app/home')
page.redirect('/app/', '/app/home')
page('/app/home', async function (context) {
  await loadPageStarter()

  showHomePage()
})

// Aug 2025: routes & pages together
adminRoutes('/app/admin')
setupAuthRoutes('/app/auth')
setupUserRoutes('/app/me')
setupInviteRoutes('/app/invite')
setupXeroConnectRoutes('/app/xero-connected')
setupAccountRoutes('/app')
setupFinancialsRoutes('/app/financials')
appEntityRoutes('/app/entity')
setupMongoToPgRoutes('/app')

setRoutersProductionPulse('/production-pulse')

// Other features
setupOtherFeaturesRoutes('/app')

// console.log('base=', page.base())

// Catch-all route for front end
page('/app/*', async function (context) {
  console.log('other routes', context)
  showPage404()
})

// Initialize the router
page()
